module.exports = __webpack_public_path__ + "static/homepage_hero2-a6952601a27fbe3ea6ed164556ecc207.jpg";